exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.train-log[data-v-993ca13c] {\r\n  background: #f5f5f5;\r\n  border: 1px solid #e8e8e8;\r\n  border-radius: 4px;\r\n  padding: 8px 12px;\r\n  font-family: monospace;\r\n  font-size: 12px;\r\n  max-height: 200px;\r\n  overflow: auto;\r\n  white-space: pre-wrap;\n}\r\n", ""]);

// exports
